export default function(place) {    
    let pieces = []
    let output = "";

    if(place.address == undefined){
        return "";
    }

    
    [place.address.road, place.address.house_number].forEach(element => {
        if(element !== undefined){
            pieces.push(element)
        }
    });
    output += pieces.join(" ");

    if(output.length > 1){
        output +=  ", ";
    }

    pieces = [];
    [place.address.city, place.address.town, place.address.county, place.address.postcode].forEach(element => {
        if(element !== undefined){
            pieces.push(element)
        }
    });
    output += pieces.join(", ");

    return output.trim();
}